<template>
  <div style="width: 100%;height:auto;">
    <nut-scroller type="vertical" :is-loading="isLoading" :is-un-more="isNoMore" :pulldown-txt="downText"
                  :load-more-txt="loadMoreText" @loadMore="loadMoreClick"
                  :unload-more-txt="noMoreText" @pulldown="pullDownClick">
      <slot name="list" slot="list"></slot>
    </nut-scroller>
    <no-data :data="data"/>
  </div>
</template>

<script>
/**
 * MList 列表组件 <br>
 * 封装nut-scroller ,no-data 等组件 <br>
 * 支持下拉刷新 上拉加载 无数据优化显示<br>
 * 若要支持分页 须在 @loadlist 回调加载数据方法 然后在回调方法实现组件setRes(data)方法  传入请求服务器返回的data数据
 */
export default {
  name: 'MList',
  props: {
    /**
     * 传入数据用于判断当前是否显示 判断依据<br>
     * 注: 必须添加.sync 修饰符 用于支持父组件数据更新
     * array 空数组<br>
     * object 空对象<br>
     * string 空字符串<br>
     * Number 0<br>
     * val null<br>
     */
    data: {
      type: Object | Array | String | Number,
      default: null
    },
    /**
     * 分页参数 数据起始页 <br>
     *  注: 必须添加.sync 修饰符 用于支持父组件数据更新
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 分页参数 每页数据大小<br>
     * 注: 必须添加.sync 修饰符 用于支持父组件数据更新
     */
    limit: {
      type: Number,
      default: 20
    },
    /**
     * 下拉刷新文案*/
    downText: {
      type: String,
      default: '下拉刷新'
    },
    /**
     * 上拉加载更多文案*/
    loadMoreText: {
      type: String,
      default: '上拉加载'
    },
    /**
     * 没有更多了 文案*/
    noMoreText: {
      type: String,
      default: '没有更多了'
    }
  },
  data () {
    return {
      isLoading: false,
      isNoMore: false,
      totalCounts: 0,
      //加载类型 0.下拉刷新 1.上拉加载
      loadingType: 0
    }
  },
  methods: {
    /**设置data数据*/
    setRes (res) {
      //停止加载
      this.isLoading = false
      let {data, count} = res
      //设置数据
      if (this.page > 1) {
        this.$emit('update:data', this.data.concat(data))
      } else {
        this.$emit('update:data', data)
      }
      //判断是否还有更多数据
      if (this.data.length < count) {
        this.isNoMore = false
      } else {
        this.isNoMore = true
      }
      this.totalCounts = count
    },
    /**
     * 下拉刷新回调
     */
    pullDownClick () {
      if (this.page * this.limit <= this.totalCounts) {
        this.isLoading = true
        this.loadingType = 0
        this.$emit('update:page', this.page + 1)
        this.$emit('loadlist')
      }
    },
    /**上拉更多回调*/
    loadMoreClick () {
      if (this.page * this.limit <= this.totalCounts) {
        this.isLoading = true
        this.loadingType = 1
        this.$emit('update:page', this.page + 1)
        this.$emit('loadlist')
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/comp/MList/MList.vue